import { render } from "./TypeCoverage.vue?vue&type=template&id=392260ec&scoped=true"
import script from "./TypeCoverage.vue?vue&type=script&lang=js"
export * from "./TypeCoverage.vue?vue&type=script&lang=js"

import "./TypeCoverage.vue?vue&type=style&index=0&id=392260ec&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-392260ec"

export default script